var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconJpn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45V30H0V0Z",
    fill: "#E2E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0911 10.1467V21.2641H33.5684L28.2738 13.6081V21.2641H26.0444V10.1467H28.5671L33.8618 17.8467V10.1467H36.0911Z",
    fill: "#3C3C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3668 16.0134C22.4228 16.0134 23.0828 15.2507 23.0828 14.0334C23.0828 12.8161 22.4228 12.0534 21.3668 12.0534H18.7708V16.0134H21.3668ZM16.5415 21.2641V10.1467H21.4402C23.7135 10.1467 25.3122 11.7454 25.3122 14.0334C25.3122 16.3214 23.7135 17.9201 21.4402 17.9201H18.7708V21.2641H16.5415Z",
    fill: "#3C3C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.995 17.7147C14.995 19.8561 13.411 21.3667 11.167 21.3667C9.67099 21.3667 8.21899 20.4867 7.63232 19.2254L9.61232 18.2427C9.93499 18.9467 10.595 19.4307 11.211 19.4307C12.1203 19.4307 12.7657 18.7121 12.7657 17.6854V10.1467H14.995V17.7147Z",
    fill: "#3C3C3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJpn);
export default __webpack_public_path__ + "static/media/icon_jpn.97943b6c602033e1a690c61b1f65a42a.svg";
export { ForwardRef as ReactComponent };